import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCondicionFiscal, clearCondicionFiscal } from "../actions";
import makeStyles from "@material-ui/styles/makeStyles";
import CondicionFiscalSelector from "~business/condicionFiscalSelector/CondicionFiscalSelector";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";

const useStyles = makeStyles((theme) => ({
  cotizador: {
    flexDirection: "row",
    margin: "auto",
    padding: 20,
    paddingBottom: 100,
    maxWidth: 500,
    width: "100%",
    minHeight: "100vh",
  },
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useSelector((state) => ({
    condicionFiscalSelected:
      state.multicotizadorReducer.condicionFiscalSelected,
  }));

const CondicionFiscalStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { condicionFiscalSelected } = useReduxSelector();

  useEffect(() => {
    dispatch(clearCondicionFiscal());
  }, [dispatch]);

  const handleChange = (event) => {
    dispatch(setCondicionFiscal(event.target.value));
  };

  return (
    <>
      <div className={classes.cotizador}>
        <div className={classes.title}>
          <PrimaryTitle
            label="¿Cuál es la condición fiscal del asegurado?"
            marginBottom={32}
          />
        </div>
        <CondicionFiscalSelector
          value={condicionFiscalSelected}
          onChange={handleChange}
        />
      </div>
    </>
  );
});

export default CondicionFiscalStep;
